export default {"src":"/_next/static/media/facebook-orig.8d87eb3b.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};